import React from 'react';

const Footer = () => (
  <footer className="bg-secondary text-white text-center py-2">
    &copy; {new Date().getFullYear()} HarmonySense Admin Panel
  </footer>
);

export default Footer;